import React, { useState } from "react";

// 🧠 Appel de ton proxy PHP (Chatbase)
async function askGPT(question, history = []) {
  const res = await fetch("https://djatervoyage.com/backend_djatervoyage/ai/chatbase_proxy.php", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ question, history })
  });
  const data = await res.json();
  console.log("Réponse Chatbase:", data);
  return data.output?.text || data.text || "Désolé, je n’ai pas compris.";
}

export default function AITravelAssistant() {
  const [messages, setMessages] = useState([
    { sender: "ai", text: "Bonjour 👋 ! Je suis l’assistant Djater Voyage. Que voulez vous savoir Sur nous?" }
  ]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [history, setHistory] = useState([]);

  const handleSend = async () => {
    if (!input.trim()) return;
    const question = input.trim();

    const newHistory = [...history, { role: "user", content: question }];
    setMessages((m) => [...m, { sender: "user", text: question }]);
    setInput("");
    setLoading(true);

    try {
      const reply = await askGPT(question, newHistory);
      setMessages((m) => [...m, { sender: "ai", text: reply }]);
      setHistory([...newHistory, { role: "assistant", content: reply }]);
    } catch (err) {
      setMessages((m) => [
        ...m,
        { sender: "ai", text: "Désolé, une erreur est survenue avec le serveur IA." },
      ]);
    }

    setLoading(false);
  };

  return (
    <div className="fixed bottom-6 right-6 z-50 w-80 bg-white rounded-2xl shadow-2xl border border-blue-200 flex flex-col">
      <div className="bg-blue-600 text-white px-4 py-3 rounded-t-2xl font-bold">
        Assistant Djater Voyage
      </div>

      <div className="flex-1 p-4 overflow-y-auto space-y-3" style={{ maxHeight: 320 }}>
        {messages.map((msg, idx) => (
          <div key={idx} className={`text-sm ${msg.sender === "ai" ? "text-blue-700" : "text-gray-800 text-right"}`}>
            <span className={`inline-block px-3 py-2 rounded-xl ${msg.sender === "ai" ? "bg-blue-50" : "bg-gray-100"}`}>
              {msg.text}
            </span>
          </div>
        ))}
        {loading && <div className="text-blue-400">L’assistant réfléchit...</div>}
      </div>

      <div className="p-3 border-t flex gap-2">
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          className="flex-1 border rounded-lg px-3 py-2"
          placeholder="Posez votre question…"
          disabled={loading}
        />
        <button
          onClick={handleSend}
          className="bg-blue-600 text-white px-4 py-2 rounded-lg font-semibold"
          disabled={loading}
        >
          Envoyer
        </button>
      </div>
    </div>
  );
}
